var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelTrafficFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: -0.059,
    y: -0.059,
    fill: "#1877F2",
    rx: 32
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.724 0 0 6.735 0 15.024c0 7.525 5.541 13.753 12.759 14.839l.783.118V18.142H9.998V15.74h3.544v-3.192c0-1.965.47-3.26 1.25-4.072.78-.812 1.932-1.222 3.535-1.222 1.281 0 1.78.078 2.254.136v1.968h-1.669c-.946 0-1.723.529-2.126 1.233-.403.705-.529 1.547-.529 2.404v2.744h4.175l-.372 2.403h-3.803V30l.774-.105C24.35 28.9 30 22.623 30 15.024 30 6.734 23.276 0 15 0zm0 1.366c7.54 0 13.636 6.107 13.636 13.658 0 6.645-4.748 12.11-11.015 13.34v-8.857h3.609l.792-5.135H17.62v-1.378c0-.709.13-1.343.347-1.725.218-.381.429-.547.944-.547h3.033v-4.57l-.592-.08c-.409-.055-1.342-.185-3.026-.185-1.843 0-3.425.503-4.518 1.641-1.092 1.138-1.63 2.832-1.63 5.02v1.825H8.634v5.135h3.543v8.813C6.012 27.012 1.364 21.597 1.364 15.024 1.364 7.473 7.46 1.366 15 1.366z",
    transform: "translate(8 8) translate(9 9)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelTrafficFacebook);
export default __webpack_public_path__ + "static/media/illustrations-funnel-traffic-facebook.c7f36cf3.svg";
export { ForwardRef as ReactComponent };